(function () {
  'use strict';
  angular
    .module('com.module.sharedservices')
    .service('AccountService', function () {

      var criteria = {
        'password':'Passwords must be at least 8 characters in length.'
      }

      var getCriteria = function(key) {
        return criteria[key];
      }

      var matchesCriteriaZip = function(str) {
        console.log( str );
        var re = /^([0-9]{5})(-[0-9]{4})?|[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/;
        return re.test(str);
      }

      var matchesCriteriaPassword = function(str) {
        // at least one number, one uppercase letter
        // at least eight characters
        var re = /.{8,}/;
        return re.test(str);
      }

      return {
        getCriteria: getCriteria,
        matchesCriteriaZip: matchesCriteriaZip,
        matchesCriteriaPassword: matchesCriteriaPassword
      }
    });
})();



// WEBPACK FOOTER //
// ./js/services/account.service.js